var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 72,
    viewBox: "0 0 18 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4098_40474)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 71.4C0 71.6 0 71.8 0 72H13.8C16 72 17.8 70.2 17.8 68V4C17.8 1.8 16 0 13.8 0H0V71.4Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2901 36.0006L11.5901 35.3006L11.9901 36.0006L11.5901 36.7006L10.2901 36.0006ZM5.8901 30.7006C5.4901 30.0006 5.7901 29.1006 6.4901 28.7006C7.1901 28.3006 8.1901 28.6006 8.5901 29.3006L5.8901 30.7006ZM8.5901 42.7006C8.1901 43.4006 7.1901 43.7006 6.4901 43.3006C5.7901 42.9006 5.4901 42.0006 5.8901 41.3006L8.5901 42.7006ZM8.9901 36.7006L5.8901 30.7006L8.5901 29.3006L12.0901 36.0006L8.9901 36.7006ZM5.8901 41.3006L8.6901 35.9006L8.9901 35.3006L12.0901 36.0006L8.5901 42.7006L5.8901 41.3006Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4098_40474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 72,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.df47f93139fb893fae4d3fdd012fc5d1.svg";
export { ForwardRef as ReactComponent };